export default __webpack_public_path__ + "static/media/leftArrow.cafbc2ce.svg";